import { useState } from 'react';

export const useNotification = () => {
  const [notification, setNotification] = useState({
    isOpen: false,
    type: 'info',
    title: '',
    message: ''
  });

  const showNotification = (type, message, title = '') => {
    console.log('🔔 [useNotification] showNotification called:', { type, message, title });
    setNotification({
      isOpen: true,
      type,
      title,
      message
    });
    console.log('🔔 [useNotification] State should be updated now');
  };

  const closeNotification = () => {
    setNotification({
      isOpen: false,
      type: 'info',
      title: '',
      message: ''
    });
  };

  return {
    notification,
    showNotification,
    closeNotification,
    // Helper methods for different types
    showSuccess: (message, title = '') => showNotification('success', message, title),
    showError: (message, title = '') => showNotification('error', message, title),
    showWarning: (message, title = '') => showNotification('warning', message, title),
    showInfo: (message, title = '') => showNotification('info', message, title)
  };
};
